import { render } from "./bootstrap-col.vue?vue&type=template&id=132ddbee"
import script from "./bootstrap-col.vue?vue&type=script&lang=js"
export * from "./bootstrap-col.vue?vue&type=script&lang=js"

import "./bootstrap-col.vue?vue&type=style&index=0&id=132ddbee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__